import request from '@/router/axios'

// 问卷列表
export function getQuestionnaireList (param) {
  return request({
    url: '/questionnaire/admin/questionnaire/page',
    method: 'GET',
    params: param,
  })
}

// 获取小程序二维码
export function getQuestionnaireMiniProgramCode(id) {
  return request({
    url: `/questionnaire/admin/questionnaire/mini-program-code/${id}`,
    method: 'GET',
  })
}

export function fetchEnrollScopes() {
  return request({
    url: '/admin/admin/member/organization-tag/all',
    method: 'get',
  })
}

// 新增问卷
export function createQuestionnaire (data) {
  return request({
    url: '/questionnaire/admin/questionnaire',
    method: 'POST',
    data,
  })
}

// 复制问卷
export function copyQuestionnaire (id) {
  return request({
    url: `/questionnaire/admin/questionnaire/copy/${id}`,
    method: 'POST',
  })
}

// 编辑问卷
export function editQuestionnaire (data) {
  return request({
    url: `/questionnaire/admin/questionnaire/${data.id}`,
    method: 'PUT',
    data,
  })
}

//删除问卷
export function delQuestionnaire (id) {
  return request({
    url: `/questionnaire/admin/questionnaire/${id}`,
    method: 'DELETE',
  })
}

// 暂停或开启调查问卷
export function updateQuestionnaireStatus (id, status, isSendMessage, message) {
  return request({
    url: `/questionnaire/admin/questionnaire/${id}/status/${status}`,
    method: 'PUT',
    params: {
      isSendMessage,
      message,
    },
  })
}

// 问卷详情
export function getQuestionnaireDetail (id) {
  return request({
    url: `/questionnaire/admin/questionnaire/${id}`,
    method: 'GET',
  })
}

// 获取问卷已作答名单
export function getAnsweredMemberList(params) {
  return request({
    url: `/questionnaire/admin/questionnaire-record/page`,
    method: 'GET',
    params,
  })
}

// 获取某人的作答情况
export function getQuestionnaireRecord(questionnaireRecordId) {
  return request({
    url: `/questionnaire/questionnaire-record`,
    method: 'GET',
    params: {
      questionnaireRecordId,
      recordSelectByType: 2,
    }
  })
}

// 导出作答记录
export function exportQuestionRecords(params) {
  return request({
    url: `/questionnaire/admin/questionnaire-record/export`,
    method: 'GET',
    params,
  })
}

